module.exports = __webpack_public_path__ + "img/symbol_5.d98d628c.png";